module.exports = __webpack_public_path__ + "img/logo.3816b56f.png";